"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _degreesToRadians = _interopRequireDefault(require("../../utils/numbers/degreesToRadians"));

var _isNumber = _interopRequireDefault(require("../../utils/numbers/isNumber"));

var _roundToDecimal = _interopRequireDefault(require("../../utils/numbers/roundToDecimal"));

var Point = /*#__PURE__*/function () {
  (0, _createClass2["default"])(Point, null, [{
    key: "isPoint",

    /**
     * Checks if object is an instance of Point
     *
     * @param inputObject
     * @returns {boolean}
     */
    value: function isPoint(inputObject) {
      return inputObject instanceof Point;
    }
    /** @private {number} */

  }]);

  /**
   * @param {number=} x
   * @param {number=} y
   */
  function Point() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    (0, _classCallCheck2["default"])(this, Point);
    (0, _defineProperty2["default"])(this, "_x", 0);
    (0, _defineProperty2["default"])(this, "_y", 0);
    this.x = x;
    this.y = y;
  }
  /** @returns {number} */


  (0, _createClass2["default"])(Point, [{
    key: "getAngleFromOrigin",

    /**
     * Gets the angle in degrees to this point from the given Point origin.
     * This implementation is a JavaScript version of:
     *
     * https://stackoverflow.com/questions/22888773/how-to-get-angle-of-point-from-center-point
     *
     * @param origin
     * @returns {number}
     */
    value: function getAngleFromOrigin(origin) {
      return Math.atan2(this.y - origin.y, this.x - origin.x) * 180 / Math.PI;
    }
    /**
     * Rotates this point around another given point (clockwise) on an inverted coordinate space
     *     -y
     *   -x   x
     *      y
     *
     * This updates this point's X,Y
     *
     * @param centerPoint
     * @param angleInDegrees
     */

  }, {
    key: "rotateAroundPoint",
    value: function rotateAroundPoint(centerPoint, angleInDegrees) {
      var angleInRadians = (0, _degreesToRadians["default"])(angleInDegrees);
      var cos = Math.cos(angleInRadians);
      var sin = Math.sin(angleInRadians);
      var centerX = centerPoint.x,
          centerY = centerPoint.y;
      var pointX = this.x,
          pointY = this.y; // Rounding because 99.99999999 does not equal 100, nor does 100.000000001

      this._x = (0, _roundToDecimal["default"])(cos * (pointX - centerX) - sin * (pointY - centerY)) + centerX;
      this._y = (0, _roundToDecimal["default"])(sin * (pointX - centerX) + cos * (pointY - centerY)) + centerY;
    }
  }, {
    key: "x",
    get: function get() {
      return this._x;
    }
    /**
     * @param {number} value
     */
    ,
    set: function set(value) {
      if ((0, _isNumber["default"])(value)) {
        this._x = value;
      }
    }
    /** @returns {number} */

  }, {
    key: "y",
    get: function get() {
      return this._y;
    }
    /**
     * @param {number} value
     */
    ,
    set: function set(value) {
      if ((0, _isNumber["default"])(value)) {
        this._y = value;
      }
    }
  }]);
  return Point;
}();

exports["default"] = Point;